"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    function options(optionsArg, updatingFlag) {
        // tslint:disable-next-line:variable-name
        var _computed = $dyn.computed(function () {
            var optionsVar;
            if (typeof optionsArg === "function") {
                optionsVar = optionsArg();
            }
            else {
                optionsVar = optionsArg;
            }
            var optionsObject = {};
            // tslint:disable-next-line:forin
            for (var option in optionsVar) {
                optionsObject[option] = $dyn.value(optionsVar[option]);
            }
            return optionsObject;
        });
        _computed.__isOptions = true;
        // Skip the initial event firing if the updatingFlag is currently non-falsy.
        if ($dyn.isObservable(updatingFlag)) {
            $dyn.makeDependentOn(_computed, updatingFlag);
        }
        return _computed;
    }
    $dyn.options = options;
    // tslint:disable-next-line:no-shadowed-variable
    function makeDependentOn(computed, updatingFlag) {
        computed.__skipFirstTimeFire = computed._notificationPending = !!$dyn.peek(updatingFlag);
        if (updatingFlag && !computed.__updatingFlagChanged) {
            // Add an attached property for updating flag changed
            computed.__updatingFlagChanged = function (updating) {
                if (!$dyn.peek(updating) && computed._notificationPending) {
                    if (computed.valueChanged.isUpdating === false) {
                        computed._notificationPending = false;
                        computed.valueChanged.raise();
                    }
                    // The computed does not need to be notified when the updating flag is changed and there is not dependency changed.
                    updatingFlag.valueChanged.unsubscribe(computed.__updatingSubscription);
                    computed.__updatingSubscription = undefined;
                }
            };
            if ($dyn.peek(updatingFlag) && !computed.__updatingSubscription) {
                // Only need to subscribe to changes when an update is in progress and a dependency has changed.
                computed.__updatingSubscription = updatingFlag.valueChanged.subscribe(computed.__updatingFlagChanged);
            }
            computed.valueChanged.onDependencyChanged = function () {
                if (computed.valueChanged.isUpdating === false) {
                    if (!$dyn.peek(updatingFlag)) {
                        computed.valueChanged.raise();
                    }
                    else {
                        computed._notificationPending = true;
                        if (!computed.__updatingSubscription) {
                            // Only need to subscribe to changes when an update is in progress and a dependency has changed.
                            computed.__updatingSubscription = updatingFlag.valueChanged.subscribe(computed.__updatingFlagChanged);
                        }
                    }
                }
            };
        }
    }
    $dyn.makeDependentOn = makeDependentOn;
    function performChange(obj, prop, value) {
        var propValue = obj[prop];
        if (!$dyn.isObservable(propValue)) {
            obj[prop] = value;
            return;
        }
        propValue.__changes = obj.__change || [];
        var oldValue = $dyn.peek(propValue);
        propValue.__changes.push({ object: obj, type: "update", name: prop, oldValue: oldValue });
        if (oldValue !== value) {
            if (propValue.valueChanged instanceof $dyn.computed._ComputedHost) {
                obj.valueChanged.setter(value);
            }
            else {
                propValue._current = value;
            }
            if (!propValue.__microTaskScheduled) {
                propValue.__microTaskScheduled = true;
                $dyn.microTask(function () {
                    propValue.__changes = undefined;
                    propValue.__microTaskScheduled = false;
                    propValue.valueChanged.raise();
                });
            }
        }
    }
    $dyn.performChange = performChange;
    function computed(getter, setter, thisVariable) {
        return (new $dyn.computed._ComputedHost(getter, setter, thisVariable))._computed;
    }
    $dyn.computed = computed;
    (function (computed) {
        // tslint:disable-next-line:class-name
        var _ComputedHost = /** @class */ (function (_super) {
            __extends(_ComputedHost, _super);
            /**
             * Constructor for the $dyn.computed._ComputedHost class
             * @param getter Getter function that is invoked upon registration and will be invoked when an observable accessed within its scope changes.
             * @param setter Setter function
             * @param thisVariable The this variable for executing the getter/setter
             */
            function _ComputedHost(getter, setter, thisVariable) {
                var _this = _super.call(this) || this;
                _this.getter = getter;
                _this.setter = setter;
                _this._computed = Object.assign(function (newValue, forceChange) {
                    if (arguments.length > 0) {
                        return this.setValue(newValue, forceChange);
                    }
                    else {
                        return this.getValue();
                    }
                }.bind(_this), {
                    __isOptions: false,
                    _current: undefined,
                    toString: function () { return _this.toString(); },
                    valueChanged: _this,
                });
                _this.that = thisVariable;
                return _this;
            }
            /**
             * Add a dependency on the to this scope
             */
            _ComputedHost.prototype.addDependency = function (dependency) {
                if (this.dependencies === undefined) {
                    this.dependencies = {};
                }
                if (this._computed === dependency) {
                    throw new Error("Circular dependency");
                }
                if (!this.dependencies[dependency.valueChanged.id]) {
                    // subscribe to the dependency observable
                    this.dependencies[dependency.valueChanged.id] = [
                        dependency,
                        dependency.valueChanged.subscribe(this.onDependencyChanged, this),
                    ];
                }
            };
            /**
             * Unsubscribe from and clear all existing dependencies.
             */
            _ComputedHost.prototype.clearAllDependencies = function () {
                if (this.dependencies) {
                    // tslint:disable-next-line: forin
                    for (var dependencyId in this.dependencies) {
                        var dependency = this.dependencies[dependencyId];
                        var eventHost_1 = dependency[0].valueChanged;
                        var subscriptionId = dependency[1];
                        eventHost_1.unsubscribe(subscriptionId);
                        if (eventHost_1.lastSeenScope === this._computed) {
                            eventHost_1.lastSeenScope = undefined;
                        }
                    }
                    this.dependencies = undefined;
                }
                if (this.lastSeenScope) {
                    this.lastSeenScope = undefined;
                }
            };
            /**
             * Fetch the current value of the computed without creating a dependency.
             */
            _ComputedHost.prototype.peek = function () {
                return this.getter.apply(this.that);
            };
            Object.defineProperty(_ComputedHost.prototype, "value", {
                /**
                 * Access the value at runtime
                 */
                get: function () {
                    return this.peek();
                },
                enumerable: false,
                configurable: true
            });
            _ComputedHost.prototype.raise = function () {
                _super.prototype.raise.call(this, this._computed);
            };
            /**
             * Handler for when any of the dependencies change. Triggers the value-changed to propagate the changes
             */
            _ComputedHost.prototype.onDependencyChanged = function () {
                if (this.isUpdating === false) {
                    this.raise();
                }
            };
            /**
             * Fetch the current value of the computed.
             */
            _ComputedHost.prototype.getValue = function () {
                var parentScope = $dyn.computed.scope;
                $dyn.computed.scope = this._computed;
                // call getter
                this.isUpdating = true;
                this._computed._current = this.getter.apply(this.that);
                this.isUpdating = false;
                $dyn.computed.scope = parentScope;
                // Wire-up dependency with the outer scope, lastSeenScope is a perf optimization
                if (parentScope && this.lastSeenScope !== parentScope) {
                    parentScope.valueChanged.addDependency(this._computed);
                    this.lastSeenScope = parentScope;
                }
                return this._computed._current;
            };
            /**
             * Set the current value of the computed.
             * @param newValue The new value
             * @param forceChange Force the value to update, even if it appears the same as the previous value.
             */
            _ComputedHost.prototype.setValue = function (newValue, forceChange) {
                if (forceChange === void 0) { forceChange = false; }
                if (this.setter) {
                    this.isUpdating = true;
                    this.setter.call(this.that, newValue, forceChange);
                    this.isUpdating = false;
                    this.raise();
                }
                return newValue;
            };
            _ComputedHost.prototype.toString = function () {
                return this._computed._current + " [Computed]";
            };
            return _ComputedHost;
        }($dyn.eventHost));
        computed._ComputedHost = _ComputedHost;
    })(computed = $dyn.computed || ($dyn.computed = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Computed.js.map
